import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Place this INSIDE <BrowserRouter>, above your <Routes>.
 * On every route change (pathname change), it scrolls the window to top.
 * This fixes React Router NOT auto-scrolling to top on navigation.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  return null;
}
